import { render } from "./editquotation.vue?vue&type=template&id=0dd0af78&scoped=true"
import script from "./editquotation.vue?vue&type=script&lang=js"
export * from "./editquotation.vue?vue&type=script&lang=js"

import "./editquotation.vue?vue&type=style&index=0&id=0dd0af78&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd0af78"]])

export default __exports__